var map = {
	"./icon-custom-checkbox-disabled.png": "90a3",
	"./icon-custom-checkbox.png": "f839",
	"./icon-custom-checkout-checked.png": "b083",
	"./icon-custom-radio-checked.png": "dc07",
	"./icon-custom-radio-disabled.png": "8a8c",
	"./icon-custom-radio.png": "788f",
	"./img-box-2021-left.png": "fc3c",
	"./img-box-2021-right.png": "80a7",
	"./img-box-about-hello-left.png": "0956",
	"./img-box-about-hello-right.png": "3a78",
	"./img-box-covid19-left.png": "318a",
	"./img-box-covid19-right.png": "b54d",
	"./img-box-products-magento-1x-left.png": "c5c2",
	"./img-box-products-magento-1x-right.png": "0591",
	"./img-box-products-magento-2x-left.png": "99b3",
	"./img-box-products-magento-2x-right.png": "328c",
	"./img-box-services-banner-left.png": "2388",
	"./img-box-services-banner-right.png": "387e",
	"./img-box-services-design-left.png": "8e6e",
	"./img-box-services-design-right.png": "14d9",
	"./img-box-services-frontend-development-left.png": "e391",
	"./img-box-services-frontend-development-right.png": "88c2",
	"./img-box-services-landing-page-left.png": "5103",
	"./img-box-services-landing-page-right.png": "2d20",
	"./img-box-services-sitebuild-left.png": "7ae4",
	"./img-box-services-sitebuild-right.png": "29aa",
	"./img-box-services-support-left.png": "56e1",
	"./img-box-services-support-right.png": "a3ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ccb7";